// package imports
import React, { useState } from 'react';

// CSS imports
import './AdminUserCard.css';

// Component imports
import DropdownSelector from '../dropdownSelector/DropdownSelector';
import DeleteButton from '../buttons/deleteButton/DeleteButton';
import PrimaryButton from '../buttons/primaryButton/PrimaryButton';
import Spinner from '../spinner/Spinner';

// Image imports
import DefaultUser from '../../assets/images/defaultUser.jpg';

// Type imports
import { User } from '../../types/user/User';

// Special imports
import { config } from '../../config';

type Props = {
  className?: string;
  loggedInUser: User;
  user: User;
  index: number;
  deleteUser: (id: string, x: number) => Promise<void>;
  updateUser: (id: string, index: number, role: string) => Promise<void>;
};

const AdminUserCard: React.FC<Props> = ({
  className,
  loggedInUser,
  user,
  index,
  deleteUser,
  updateUser,
}: Props) => {
  const [selectedRole, setSelectedRole] = useState(
    config.roles.findIndex((role) => role === user.role) !== -1
      ? config.roles.findIndex((role) => role === user.role)
      : 0
  );
  const [isLoading, setIsLoading] = useState(false);

  const onRoleChange = (newRole: number) => {
    setSelectedRole(newRole);
  };

  const triggerDeleteUser = async () => {
    setIsLoading(true);
    await deleteUser(user.id, index);
    setIsLoading(false);
  };

  const triggerUpdateUser = async () => {
    setIsLoading(true);
    await updateUser(user.id, index, config.roles[selectedRole]);
    setIsLoading(false);
  };

  return (
    <div className={`AdminUserCard ${className ? className : ''}`}>
      <div className='side-container'>
        <img src={DefaultUser} alt='Default user' />
        <span>{user.email}</span>
      </div>
      <div className='side-container'>
        <DropdownSelector
          selectedElement={selectedRole}
          elements={config.roles.map((role, index) => {
            return {
              value: index,
              label: role,
            };
          })}
          onChange={onRoleChange}
          disabled={loggedInUser.id === user.id}
          className='role-selector'
        />
        {loggedInUser.id !== user.id ? (
          <>
            <PrimaryButton
              label='Save'
              onClick={triggerUpdateUser}
              className='save-button'
            />
            <DeleteButton onClick={triggerDeleteUser} />
          </>
        ) : null}
      </div>
      {isLoading ? (
        <div className='loader-overlay'>
          <Spinner isLoading={true} />
        </div>
      ) : null}
    </div>
  );
};

export default AdminUserCard;
